import { Component } from '@angular/core';
import { RouterOutlet, Router, NavigationEnd } from '@angular/router';
import { STORAGE_KEYS, StorageService } from '@core/services/storage.service';
import { updateSurfacePalette } from '@primeng/themes';
import { ButtonModule } from 'primeng/button';
import { darkGraySurfacePalette, lightGraySurfacePalette } from './app.palette';
import { MessageService } from 'primeng/api'; // TOAST
import { ToastModule } from 'primeng/toast'; // TOAST
import { ConsoleInterceptor } from '@core/interceptors/console.interceptor';
import { filter } from 'rxjs';
import { ThemeService } from '@shared/services/theme-service';

@Component({
   selector: 'app-root',
   imports: [RouterOutlet, ButtonModule, ToastModule /* TOAST */],
   providers: [MessageService], // TOAST
   templateUrl: './app.component.html',
   styles: [],
})

export class AppComponent {
   title = 'serglo';

   constructor(
      private storageService: StorageService,
      private consoleInterceptor: ConsoleInterceptor,
      private router: Router,
      private themeService: ThemeService
   ) {
      // inicializamos el servicio de interceptor de consola
      this.consoleInterceptor.init();

      // Escuchar cambios de ruta para aplicar tema según la ruta
      this.router.events.pipe(
         filter(event => event instanceof NavigationEnd)
      ).subscribe((event: NavigationEnd) => {
         this.applyThemeBasedOnRoute(event.urlAfterRedirects);
      });

      // Aplicar tema inicial basado en la ruta actual
      this.applyThemeBasedOnRoute(this.router.url);
   }

   private applyThemeBasedOnRoute(url: string): void {
      // Verificar si es una ruta pública (personaliza según tu aplicación)
      // Ejemplo: const isPublicRoute = url.startsWith('/public/');
      const isPublicRoute = url.includes('/public/');

      if (isPublicRoute) {
         // Para rutas públicas, puedes definir un tema específico
         // Por defecto, usamos tema oscuro para rutas públicas
         this.applyDarkTheme();
         this.themeService.setTheme('dark');
      } else {
         // Para rutas privadas, usar preferencia del usuario
         const darkModeEnabled = this.storageService.getItem(STORAGE_KEYS.DARK_MODE_ENABLED);

         // Si no hay preferencia guardada, usar el modo del sistema operativo
         const usarOscuro = darkModeEnabled !== null && darkModeEnabled !== undefined
            ? darkModeEnabled
            : window.matchMedia('(prefers-color-scheme: dark)').matches;

         if (usarOscuro) {
            this.applyDarkTheme();
            this.themeService.setTheme('dark');
         } else {
            this.applyLightTheme();
            this.themeService.setTheme('light');
         }
      }
   }

   private applyDarkTheme(): void {
      updateSurfacePalette(darkGraySurfacePalette);
      document.documentElement.classList.add('dark');
      document.documentElement.classList.add('app-dark');
   }

   private applyLightTheme(): void {
      updateSurfacePalette(lightGraySurfacePalette);
      document.documentElement.classList.remove('dark');
      document.documentElement.classList.remove('app-dark');
   }
}
